// Profile identifiers may arrive as strings or numbers depending on the API driver.
export function eligibleLeadAttendants(employees = [], profiles = {}) {
    const standard = new Set((profiles.standard || []).map(String));
    const custom = new Set((profiles.custom || []).map(String));
    return (employees || []).filter(employee => {
        const sector = (employee.cargo?.setor?.nome || '')
            .normalize('NFD').replace(/[\u0300-\u036f]/g, '').trim().toLowerCase();
        if (sector === 'corpo clinico') return false;
        // A custom profile takes precedence over a standard role.
        if (employee.entidade_perfil_id != null) {
            return custom.has(String(employee.entidade_perfil_id));
        }
        return employee.standard_role_id != null && standard.has(String(employee.standard_role_id));
    });
}
